<template>
  <div class="schools">
    <!-- Schools Tit Starts -->
    <section class="schools-tit">
      <div class="schools-tit-content">
        Schools
      </div>
    </section>
    <!-- Schools Tit End -->


    <!-- Schools List Starts -->
    <section class="schools-list">

      <div class="container">
        <div class="row">
          <template v-for="(item,index) in schoolsList">
            <div class="col-md-3" :key="index+'coll'">
              <div class="schools-list-item2 wow flipInY"  >
<!--                <div class="schools-list-item2-img">-->
<!--                  <img :src="item.img" alt="school">-->
<!--                </div>-->
                <!--                  <div class="collaboration-list-item-logo">-->
                <!--                    <img :src="item.logo" alt="school">-->
                <!--                  </div>-->
                <div class="schools-list-item2-content" >
                  <div class="schools-list-item2-content-box">
                    <div class="schools-list-item2-content-tit">{{ item.title }}</div>
                    <div class="schools-list-item2-content-dec">
                      <p style="margin-bottom: 0;">
                        {{ item.desc }}
                      </p>
                    </div>
                    <div class="schools-list-item2-content-more" @click="goTo(item.id)">More …</div>
                  </div>
                </div>
              </div>

            </div>
          </template>
        </div>
      </div>
      <!--        <div class="row">-->
      <!--          <div class="col-lg-12">-->
      <!--            <template v-for="(item,index) in schoolsList">-->
      <!--              <div class="schools-list-item schools-list-item-rt wow flipInX"  :key="item" v-if="(index+1) % 2 === 0">-->
      <!--                <div class="schools-list-item-img rt-img" :style="{ '&#45;&#45;bgColor': item.bgColor }">-->
      <!--                  <img :src="item.img" alt="school">-->
      <!--                </div>-->
      <!--                <div class="schools-list-item-content rt-content" >-->
      <!--                  <div class="schools-list-item-content-box">-->
      <!--                  <div class="schools-list-item-content-tit" :data-attr="index+1<10?'0'+(index+1):index+1">{{ item.title }}</div>-->
      <!--                  <div class="schools-list-item-content-dec">-->
      <!--                    <p :data-hover="item.desc">-->
      <!--                      {{ item.desc }}-->
      <!--                    </p>-->
      <!--                  </div>-->
      <!--                  </div>-->
      <!--                </div>-->
      <!--              </div>-->
      <!--              <div class="schools-list-item schools-list-item-lf wow flipInX"  :key="item" v-else>-->
      <!--                <div class="schools-list-item-img lf-img" :style="{ '&#45;&#45;bgColor': item.bgColor }">-->
      <!--                  <img :src="item.img" alt="school">-->
      <!--                </div>-->
      <!--                <div class="schools-list-item-content lf-content" >-->
      <!--                  <div class="schools-list-item-content-box">-->

      <!--                    <div class="schools-list-item-content-tit" :data-attr="index+1<10?'0'+(index+1):index+1">{{ item.title }}</div>-->
      <!--                    <div class="schools-list-item-content-dec">-->
      <!--                      <p :data-hover="item.desc">-->
      <!--                        {{ item.desc }}-->
      <!--                      </p>-->
      <!--                    </div>-->

      <!--                  </div>-->
      <!--                </div>-->
      <!--              </div>-->
      <!--            </template>-->
      <!--          </div>-->
      <!--        </div>-->


    </section>
    <!-- Schools List End -->
  </div>
</template>
<script>
  import router from '../router'

export default {
    data () {
      return {
        schoolsList: [
          {
            id: '1',
            bgColor: '#8B2929',
            title: 'Sino-French\n' +
              'Institute',
            img: 'http://en.sc.ruc.edu.cn/static/images/school/png5.png',
            desc: 'Inaugurated in June 2012, Sino-French Institute is the first Chinese-foreign cooperative educational institution focusing on...'
          },
          {
            id: '2',
            bgColor: '#DEBD9E',
            title: 'School of Smart Governance',
            img: 'http://en.sc.ruc.edu.cn/static/images/school/png9.png',
            desc: 'The School of Smart Governance was established in September 2023. Guided by the theory of intelligent governance ...'
          },
          {
            id: '3',
            bgColor: '#DF7E49',
            title: 'Silk Road School',
            img: 'http://en.sc.ruc.edu.cn/static/images/school/png7.png',
            desc: 'Silk Road School was inaugurated in May 2018, and is the first school to be named with “Silk Road” among the “Double ...'
          }, {
            id: '4',
            bgColor: '#ECD7CA',
            title: 'International\n' +
              'College',
            img: 'http://en.sc.ruc.edu.cn/static/images/school/png8.png',
            desc: 'International College (Suzhou Research Institute) was inaugurated in September 2007. On September 6, 2009, the opening ceremony ...'
          }
        ]
      }
    },
    methods: {
      goTo (id) {
        router.push({
          path: '/schoolDetails',
          query: {
            id: id
          }
        })
      }
    }
  }
</script>




// WEBPACK FOOTER //
// Schools.vue?576b7374